export enum FundingAllocationType {
  COMPUTED = 'computed',
  INHERITED = 'inherited',
}
